<h2>Confirm deletion</h2>
<div>
  <p>Do you want to remove {{ data.typeWord }} ?</p>
  <p>Name: {{ data.name }}</p>
</div>
<div class="buttons">
  <button mat-raised-button mat-dialog-close color="warn">Cancel</button>
  <button mat-raised-button [mat-dialog-close]="true" cdkFocusInitial color="primary">Ok</button>
</div>
